import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

export const BoardCommitteApprovalListConfig = {
    columns: [
        {
            name: "Name",
            fieldName: "name",
            allowShort: false,
            colType: GridColumnType.Text,
            colStyle: {
                width: "15%",
                textAlign: "center",
                color: "color",
                // backgroundColor:"lightyellow"
                //  backgroundColor: "white"
            }
        },
        {
            name: "Status",
            fieldName: "status",
            allowShort: false,
            colType: GridColumnType.Text,
            colStyle: {
                width: "15%",
                textAlign: "center",
                color: "color",
                // backgroundColor:"lightyellow"
                //   backgroundColor: "white"
            }
        },
        {
            name: "Comments",
            fieldName: "comment",
            allowShort: false,
            colType: GridColumnType.Text,
            colStyle: {
                width: "40%",
                textAlign: "center",
                color: "color",
                // backgroundColor:"lightyellow"
                //   backgroundColor: "white"
            }
        },
        {
            name: "Decision Date",
            fieldName: "approvalDate",
            colType: GridColumnType.DATE,
            allowShort: false,
            colStyle: {
                width: "15%",
                textAlign: "center",
                color: "color",
                // backgroundColor:"lightyellow"
                //  backgroundColor: "white"
            },
            colSettings: {
                format: "DD-MMM-YYYY"
            },
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: false,
                allowDelete: false
            },
            customAction: [
                {
                    name: "RESEND",
                },
            ],
        },
    ],
    allowEdit: false,
    isRowSelectable: true,
    hasChildGridTable: false,
    gridStyle: {
        tableClass: "border-table-simple"
    }
}